import { reflect } from '@effector/reflect';
import { Trash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { translated } from 'shared/lib';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { DeleteVoucherModel } from '../../model';

export const createDeleteVoucherModal = (model: DeleteVoucherModel) => {
	const ConfirmModal = createConfirmModal(model);

	const DeleteVoucherModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		return (
			<ConfirmModal
				ref={ref}
				title={t('delete-voucher.title')}
				cancelButtonProps={{
					children: t('delete-voucher.cancel'),
				}}
				submitButtonProps={{
					children: t('delete-voucher.delete'),
					variant: 'destructive',
				}}
				{...props}
			>
				{t('delete-voucher.description')}
			</ConfirmModal>
		);
	});

	const DeleteVoucherModalButton = reflect({
		view: ConfirmModal.Button,
		bind: {
			'data-test-id': 'delete-voucher-button',
			variant: 'destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			leftSection: <Trash2 />,
			children: translated('delete-voucher.delete'),
		},
	});

	const DeleteVoucherModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'delete-voucher-action-icon',
			variant: 'ghost-destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <Trash2 />,
		},
	});

	return Object.assign(DeleteVoucherModal, {
		Button: DeleteVoucherModalButton,
		ActionIcon: DeleteVoucherModalActionIcon,
	});
};
